import { render, staticRenderFns } from "./vuex-switch.vue?vue&type=template&id=39ac9a68"
import script from "./vuex-switch.vue?vue&type=script&lang=js"
export * from "./vuex-switch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports